import React        from "react";
import { Waypoint } from "react-waypoint";

import { useGetDeviceType }   from "_common/hooks/global";
import { LIVESESSION, VIDEO } from "_common/utils";
import FetchMore              from "_components/atoms/fetchMoreLoader";
import Typography             from "_components/atoms/typography";
import SearchContentBox       from "_components/molecules/searchContentBox";
import VideoCardList          from "_components/organisms/videoCardList";
import useStyles              from "_styles/organisms/searchPopularContent";

const component = props => {

	const {
		isDataDepleted,
		isFetchingData,
		activeTab,
		videoList,
		getNextData,
		isHorizontal = false
	} = props;

	const { classes } = useStyles ( { activeTab } );
	const heading     = "Related to your search";

	const customClass = {
		title                    : "1.5rem",
		detailsFont              : "1.2rem",
		image                    : "2rem",
		imgContainerWidth        : "25%",
		gap                      : "2rem",
		rowContentContainerWidth : "75%"
	};

	const formattedVideoListForMobile = formatVideoListForMobile ( videoList );

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	const mobileList = (
		<div>
			<VideoCardList
				isWithoutAnimation
				list = { formattedVideoListForMobile }
			/>

			<FetchMore
				fetchMore  = { getNextData }
				isDepleted = { isDataDepleted }
				isLoading  = { isFetchingData }
			/>
		</div>
	);

	const tabAndDesktopList = (
		<div className = { classes.content }>
			{videoList?.map ( ( session, index, arr ) => {
				const lastIndex = arr.length - 1;

				return (
					<React.Fragment key = { index }>

						<SearchContentBox
							currentIndex  = { index }
							customClass   = { customClass }
							direction     = { "row" }
							isHorizontal  = { isHorizontal }
							lastIndex     = { lastIndex }
							session       = { session }
						/>

						{ !isDataDepleted && !isFetchingData && videoList.length > 0 && index === videoList.length - 2 && (
							<Waypoint
								onEnter = { () => getNextData ( ) }
							/>
						)}
					</React.Fragment>
				);
			} )}

		</div>
	);

	return (
		<div className = { classes.popularContentWrapper }>
			{ activeTab === "all" && (
				<Typography
					className = { classes.heading }
					title     = { heading }
					weight    = "500"
				/>
			)}

			{
				isMobile ? (
					mobileList
				) : (
					tabAndDesktopList
				)
			}

		</div>
	);
};

export default component;

const formatVideoListForMobile = ( list = [] ) => {
	return list.map ( item => ( {
		id        : item?.videoId,
		createdAt : item?.createdAt,
		endedAt   : item?.endTimeUTC,
		title     : item?.streamTitle,
		isLive    : item?.feedType === "broadcast",
		userData  : {
			id          : item?.profileId,
			name        : item?.streamerName,
			photo       : item?.profilePic,
			isCeleb     : item?.isCeleb,
			isFollowing : item?.isFollowing?.isFollowing
		},
		thumbnail     : item?.thumbnail,
		src           : item?.src,
		videoDuration : item?.videoDuration,
		feedType      : item?.feedType === "broadcast" ? LIVESESSION : VIDEO,
		views         : item?.views, // totalViews, views are already there, not confirm which one should be used
		reactions     : item?.reactions || 0,
		sharesCount   : item?.sharesCount || 0,
		commentsCount : item?.commentsCount || 0
	} ) );
};
